<script setup>
import { ref, watch } from 'vue';
import { orderBy } from 'lodash';
import servicios from '../../api/cifra/servicios/servicios';
import SelectCifra from '../inputs/SelectCifra.vue';
import { isEmpty } from 'lodash';

const props = defineProps({
  multiple: { type: Boolean, value: true },
  modelValue: { type: Array, default: () => ([]) },
});

const emits = defineEmits(['update:modelValue']);

const modelInterno = ref(props.modelValue);

const options = ref([]);

servicios.servicios().then((result) => {
  // TODO: Revisar que no funcionará bien las tildes
  const data = orderBy(result.data, [(item) => item.nombre.toLowerCase()]);
  data.forEach((servicio) => {
    const servicioCursos = servicio.servicio_cursos;
    servicioCursos.forEach((servicioCurso) => {
      servicioCurso.textoParaFiltrar = `${servicio.nombre} - ${servicioCurso.nombre}`;
    });

    servicio.servicio_cursos = orderBy(
      servicioCursos,
      (item) => item.nombre.toLowerCase(),
    );
  });
  options.value = data;
});

watch(modelInterno, (value) => {
  emits('update:modelValue', value);
});

function customLabel(option, _label) {
  return option.textoParaFiltrar;
}
</script>

<template>
  <SelectCifra
    v-model="modelInterno"
    :options="options"
    :multiple="multiple"
    label="nombre"
    track-by="id"
    group-values="servicio_cursos"
    group-label="nombre"
    :group-select="true"
    :show-clear="multiple"
    :custom-label="customLabel"
  >
  </SelectCifra>
</template>
